import geodeWorldSprite from "../assets/creatures/Enemy_geode.png";
import shroomWorldSprite from "../assets/creatures/Enemy_shroom.png";
import sproutWorldSprite from "../assets/creatures/Enemy_sprout.png";

export const STORY_CREATURE_SOURCE = "storyCreature";

export const STORY_CREATURE_CARDS = Object.freeze([
  Object.freeze({
    id: "geode",
    name: "Geode",
    source: STORY_CREATURE_SOURCE,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FGeode.png?alt=media&token=e01759e0-4db0-478b-8d60-2e801bf2de6f",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FGeode-start.png?alt=media&token=46862b08-9369-4672-85b7-e15a5a78be31",
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FGeode-fin.png?alt=media&token=e5a8fb3a-28ba-494b-9ee3-24ec9cf8b640",
    imageHit:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FGeode-hit.png?alt=media&token=de8702d8-4184-46de-bed3-25d651600571",
    worldImage: geodeWorldSprite,
    spriteKey: "storyCreature-geode",
    portrait:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FGeode.png?alt=media&token=e01759e0-4db0-478b-8d60-2e801bf2de6f",
    rarity: "Common",
    element: "rock",
    attackName: "Shard Crash",
    bgColor1: "#a88d68",
    bgColor2: "#5c482e",
    stats: {
      health: 5,
      attack: 5,
      defense: 5,
      accuracy: 3,
    },
    flavor: {
      role: "Forest Bruiser",
      description:
        "A blunt corruption-born stone beast that crashes into anything still carrying clean energy.",
    },
  }),
  Object.freeze({
    id: "shroom",
    name: "Shroom",
    source: STORY_CREATURE_SOURCE,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FShroom.png?alt=media&token=78af850a-857f-490a-8ba2-da8486e34cd9f",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FShroom-start.png?alt=media&token=5b2c4189-25a1-46f3-ab62-bc9fc1c3afe9",
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FShroom-fin.png?alt=media&token=b37acffc-745d-4a69-af9d-cb02d0f98ad2",
    imageHit:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FShroom-hit.png?alt=media&token=cb5b2a5a-638f-4ae9-9fae-f030bd3ccf35",
    worldImage: shroomWorldSprite,
    spriteKey: "storyCreature-shroom",
    portrait:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FShroom.png?alt=media&token=78af850a-857f-490a-8ba2-da8486e34cd9f",
    rarity: "Common",
    element: "grass",
    attackName: "Spore Puff",
    bgColor1: "#92e787",
    bgColor2: "#2e5e39",
    stats: {
      health: 6,
      attack: 3,
      defense: 3,
      accuracy: 6,
    },
    flavor: {
      role: "Forest Disruptor",
      description:
        "A drifting fungus creature that clouds the air and turns safe ground into a hazard.",
    },
  }),
  Object.freeze({
    id: "sprout",
    name: "Sprout",
    source: STORY_CREATURE_SOURCE,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FSprout.png?alt=media&token=fec27706-9245-466c-af1f-66343e31d695",
    imageStart:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FSprout-start.png?alt=media&token=f0199482-bc5e-43ef-8d90-4994ad303fc5",
    imageFin:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FSprout-fin.png?alt=media&token=f197c24f-98e9-422d-9e9f-8b782a96be0a",
    imageHit:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FSprout-hit.png?alt=media&token=758ccc70-1ac2-4563-830f-87c19621d290",
    worldImage: sproutWorldSprite,
    spriteKey: "storyCreature-sprout",
    portrait:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/story-mode%2Fcreatures%2FSprout.png?alt=media&token=fec27706-9245-466c-af1f-66343e31d695",
    rarity: "Common",
    element: "grass",
    attackName: "Root Snap",
    bgColor1: "#4a7045",
    bgColor2: "#0e4b1c",
    stats: {
      health: 8,
      attack: 2,
      defense: 2,
      accuracy: 6,
    },
    flavor: {
      role: "Forest Striker",
      description:
        "A skittish seedling corrupted into a fast-moving ambusher that lashes out before retreating.",
    },
  }),
]);

const STORY_CREATURES_BY_ID = new Map(
  STORY_CREATURE_CARDS.map((creature) => [creature.id, creature]),
);

const normalizeBattleStat = (value) => {
  const numericValue = Number(value ?? 0);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const getStoryCreatureCard = (creatureId = "") =>
  STORY_CREATURES_BY_ID.get(
    String(creatureId || "")
      .trim()
      .toLowerCase(),
  ) || null;

// Story creatures are battle-authoritative repo data, just like Story humans,
// but they stay separate from collectible ownership and player catalog flows.
export const buildStoryCreatureBattleCharacter = (storyCreature = null) => {
  if (!storyCreature?.id) return null;

  const health = normalizeBattleStat(storyCreature?.stats?.health);
  const attack = normalizeBattleStat(storyCreature?.stats?.attack);
  const defense = normalizeBattleStat(storyCreature?.stats?.defense);
  const accuracy = normalizeBattleStat(storyCreature?.stats?.accuracy);

  return {
    id: storyCreature.id,
    source: STORY_CREATURE_SOURCE,
    name: storyCreature.name || "Story Creature",
    imageUrl: storyCreature.imageUrl || "",
    imageStart: storyCreature.imageStart || "",
    imageFin: storyCreature.imageFin || "",
    imageHit: storyCreature.imageHit || "",
    spriteKey: storyCreature.spriteKey || null,
    portrait: storyCreature.portrait || storyCreature.imageUrl || "",
    rarity: storyCreature.rarity || "Common",
    element: storyCreature.element || null,
    attackName: storyCreature.attackName || "Strike",
    bgColor1: storyCreature.bgColor1 || "#ffffff",
    bgColor2: storyCreature.bgColor2 || "#ffffff",
    health,
    attack,
    defense,
    accuracy,
    startingHealth: health,
    startingAttack: attack,
    startingDefense: defense,
    startingAccuracy: accuracy,
    stance: "defense",
    isDead: false,
    buffs: {
      attack: [],
      defense: [],
      health: [],
      accuracy: [],
    },
    flavor: storyCreature.flavor || null,
  };
};
